<template>
  <div v-if="cart.domains.length > 0">
    <StoreInit store="tld-catalog">
      <template #fallback>
        <ShoppingCartSectionSkeleton title="Domener" />
      </template>
      <StoreInit store="domain-addon-catalog">
        <template #fallback>
          <ShoppingCartSectionSkeleton title="Domener" />
        </template>

        <UDashboardCard
          :title="`Domener`"
          :description="`${cart.domains.length} domene(r) i handlekurven`"
        >
          <template #links>
            <UButton color="gray" to="/domene/sok"
              >Legg til flere domener</UButton
            >
          </template>

          <ShoppingCartDomainItem
            v-for="item in cart.domains"
            :shopping-cart-item="item"
            :key="item.id"
            :minimal="false"
          />
        </UDashboardCard>
      </StoreInit>
    </StoreInit>
  </div>
</template>

<script lang="ts" setup>
const cart = useCartStore();
</script>

<style></style>
